import { Button } from '@chakra-ui/react'

import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { EmptyState } from '../../../components/EmptyState'

export const CarkulkaSimulateStepTooFar = () => {
  return (
    <Section>
      <Container>
        <EmptyState
          title="Tento krok ještě není dostupný"
          cta={
            <Button colorScheme="primary" onClick={() => window?.history.back()}>
              Zpět na předchozí stranu
            </Button>
          }
        />
      </Container>
    </Section>
  )
}
